import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import { http } from "../axios/axios";
import ProductCard from "../component/ProductCard";
import SectionHeader from "../component/SectionHeader";
import MediaRichDetail from "../component/DetailPage/MediaRichDetail";

export default function ServiceDetails() {
  const { slug } = useParams();
  const [service, setService] = useState(null);
  const [latestProducts, setLatestProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!slug) return;
    const fetchService = async () => {
      try {
        setLoading(true);
        const [serviceRes, productsRes] = await Promise.all([
          http.get(`services/${slug}`),
          http.get("products/latest"),
        ]);
        setService(serviceRes.data.data);
        setLatestProducts(productsRes.data.products || []);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchService();
  }, [slug]);

  if (loading) {
    return <div className="flex min-h-screen items-center justify-center bg-white"><div className="h-12 w-12 animate-spin rounded-full border-4 border-gray-200 border-t-blue-600" /></div>;
  }

  if (!service) {
    return <div className="flex min-h-screen items-center justify-center"><p className="text-gray-600">Service not found.</p></div>;
  }

  const seoData = service.seo || {};
  const schemaScript = service.schemaScript
    ? typeof service.schemaScript === "string"
      ? service.schemaScript
      : JSON.stringify(service.schemaScript)
    : null;

  return (
    <>
      <Helmet>
        <title>{seoData.title || service.bannerTitle}</title>
        <meta name="description" content={seoData.description || service.bannerSubtitle} />
        <meta name="keywords" content={Array.isArray(seoData.keywords) ? seoData.keywords.join(", ") : seoData.keywords || ""} />
        {schemaScript && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: schemaScript }} />}
      </Helmet>
      <MediaRichDetail item={service} type="service" />
      {latestProducts.length > 0 && (
        <section className="bg-slate-50 py-14 lg:py-16">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <SectionHeader badge="Recommended Products" title="Explore our products" description="Reliable security products selected to support this service." showLine={false} />
            <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">{latestProducts.map((product) => <ProductCard key={product?._id} item={product} />)}</div>
          </div>
        </section>
      )}
    </>
  );
}
